<template>
  <div class="ds-page-header">
    <div class="ds-page-header__left">
      <div class="ds-page-header__title" v-if="title || $slots.title">{{ title || $slots.title }}</div>
      <div class="ds-page-header__subtitle" v-if="subtitle">{{ subtitle }}</div>
    </div>
    <div class="ds-page-header__extra" v-if="$slots.extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
/**
 * DsPageHeader —— 页面标题区
 *
 * 纯展示组件，不接管任何业务逻辑。
 *
 * Props:
 *  - title    {String}  页面主标题
 *  - subtitle {String}  副标题 / 说明文字
 *
 * Slots:
 *  - default  标题内容（优先级低于 title）
 *  - extra    右侧动作区（新增 / 导入 / 导出等）
 */
export default {
  name: 'DsPageHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-md);

  &__title {
    font-size: var(--ds-font-size-xl);
    font-weight: 600;
    color: var(--ds-gray-900);
    line-height: 1.4;
  }

  &__subtitle {
    margin-top: var(--ds-spacing-xs);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
    line-height: 1.6;
  }

  &__extra {
    display: flex;
    align-items: center;
    gap: var(--ds-spacing-sm);
    flex-shrink: 0;
  }
}
</style>
